import { render, staticRenderFns } from "./PageHeaderV2.vue?vue&type=template&id=554d9a81"
import script from "./PageHeaderV2.vue?vue&type=script&lang=js"
export * from "./PageHeaderV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports